import ToolTip from "../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return <ToolTip content={params.row.address ||"N/A"} expand={params.row.address} />;
};

export const Vendor_Table_Head = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "name",
    headerName: "Name",
    width: 200,
  },
  {
    field: "phoneNumber",
    headerName: "Phone No",
    width: 200,
         valueGetter: (params) =>
     params.value ? params.value : "N/A"
  },
  {
    field: "address",
    headerName: "Address",
    width: 200,
    renderCell: handleAssign,
  },
  {
    field: "place",
    headerName: "Place",
    width: 200,
      valueGetter: (params) =>
     params.value ? params.value : "N/A"
  },
  {
    field: "email",
    headerName: "Email ID",
    width: 200,
      valueGetter: (params) =>
      params.value ? params.value : "N/A" 
  },
  {
    field: "gst",
    headerName: "GST NO",
    width: 200,
      valueGetter: (params) =>
    params.value ? params.value : "N/A"
  },
];
